var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonPauseslideshowSvgPauseslideshow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_1041)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_1041",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0H0V13H13V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_1041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05555 0H2.88889V13H5.05555V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1111 0H7.94444V13H10.1111V0Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_1041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPauseslideshowSvgPauseslideshow1);
export default __webpack_public_path__ + "static/media/Button - Pause slideshow → SVG - Pause slideshow (1).7f12182671b68704825ba6032d49d4fd.svg";
export { ForwardRef as ReactComponent };